import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useTotalLeave = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [totalLeave, setTotalLeave] = useState(false)
  const { deleteNewTotalLeave, getNewTotalLeave } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const getAllTotalLeave = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_TOTAL_LEAVE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewTotalLeave(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addTotalLeave = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_TOTAL_LEAVE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('TotalLeave  Added Successfully', success)
        history.push(ROUTES.TOTAL_LEAVE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }
  const updateTotalLeave = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_TOTAL_LEAVE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Total Leave  Update Successfully', success)
        history.push(ROUTES.TOTAL_LEAVE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getTotalLeave = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_TOTAL_LEAVE(dto.totalLeaveId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setTotalLeave(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteTotalLeave = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_TOTAL_LEAVE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('TotalLeave Deleted Successfully', success)

        deleteNewTotalLeave(dto.totalLeaveId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManyTotalLeave = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_TOTAL_LEAVE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.totalLeaveId.length} TotalLeave Deleted Successfully`, success)

        dto.totalLeaveId.map((item) => deleteNewTotalLeave(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // data.data.map((item) => addNewReg(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addTotalLeave,
    getAllTotalLeave,
    deleteTotalLeave,
    getTotalLeave,
    totalLeave,
    updateTotalLeave,
    deleteManyTotalLeave,
    BulkUpload,
    loading,
    paginate,
  }
}
